import * as RadixPopover from '@radix-ui/react-popover';

import * as StyledPopover from './style';

export const Popover = {
  Root: RadixPopover.Root,
  Trigger: RadixPopover.Trigger,
  Portal: RadixPopover.Portal,
  Content: StyledPopover.Content,
};
